import React from 'react';
import { motion } from 'framer-motion';
export const Mechanism = () => {
  return <section className="py-24 bg-wellness-cream relative overflow-hidden" data-id="element-66">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-wellness-gold/5 rounded-full blur-3xl -z-10" data-id="element-67" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-wellness-sage/10 rounded-full blur-3xl -z-10" data-id="element-68" />

      <div className="container mx-auto px-6 max-w-4xl" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-xl border border-wellness-gold/20 relative" data-id="element-70">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-wellness-gold text-white px-6 py-2 rounded-full text-sm tracking-widest uppercase font-medium shadow-md" data-id="element-71">
            The Unique Mechanism
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-center mb-8 leading-tight mt-4" data-id="element-72">
            The secret to a flat stomach at 45 isn't "burning" fat—it's{' '}
            <span className="italic text-wellness-gold-dark" data-id="element-73">
              Lowering the Biological Alarm.
            </span>
          </h2>

          <div className="space-y-6 font-sans font-light text-lg text-wellness-forest/80 leading-relaxed" data-id="element-74">
            <p data-id="element-75">
              We use the{' '}
              <strong className="font-medium text-wellness-forest" data-id="element-76">
                Low-Cortisol Metabolic Window
              </strong>
              , a specific 7-day protocol designed to soothe your nervous system
              and flush "acidic water" from your tissues.
            </p>
            <p data-id="element-77">
              By stabilizing your insulin and feeding your adrenals exactly what
              they need, your body finally feels "safe" enough to let go of the
              midsection weight it has been hoarding.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};